import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ScheduleEventDialog = ({
  enableCalendarInvite,
  setEnablCalendarInvite,
  eventUserData,
}) => {
  const { userInfo } = useSelector((state) => state.userInfo);
  const [eventType, setEventType] = useState('');
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [location, setLocation] = useState('Online at mChatHive');
  const handleInvite = () => {
    const toastId = toast.loading('Sending invite...');

    axios
      .post(`https://soapboxapi.megahoot.net/nodemailer/event-schedule`, {
        sender: userInfo,
        recipient: {
          name: eventUserData.name,
          username: eventUserData.chatFrom,
        },
        date,
        eventType,
        location,
        time,
        title,
      })
      .then((res) => {
        toast.update(toastId, {
          render: 'Invitation sent successfully!',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
        setEnablCalendarInvite(false);
      })
      .catch((err) => {
        toast.update(toastId, {
          render: 'Failed to send invite.',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      });
  };

  return (
    <Dialog
      open={enableCalendarInvite}
      onClose={() => setEnablCalendarInvite(false)}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>
        Schedule with {eventUserData?.name} (@{eventUserData?.chatFrom})
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={2} mt={2}>
          <FormControl size="small" fullWidth>
            <InputLabel id="event-type-label">Event Type</InputLabel>
            <Select
              labelId="event-type-label"
              label="Event Type"
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
            >
              <MenuItem value="audio">Audio Call</MenuItem>
              <MenuItem value="video">Video Call</MenuItem>
            </Select>
          </FormControl>

          <TextField
            size="small"
            label="Meeting Title"
            placeholder="e.g., Project Sync"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            size="small"
            label="Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
          <TextField
            size="small"
            label="Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
          <TextField
            size="small"
            label="Location"
            placeholder="e.g., Virtual / Private Channel / Private Club"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setEnablCalendarInvite(false)} color="primary">
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={handleInvite}>
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleEventDialog;
